import React__default, { createContext, useContext, useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { createForOfIteratorHelperLoose as _createForOfIteratorHelperLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Button } from '../Button/index.js';
import { Toggle } from '../Toggle/index.js';
import styles from 'ui-components/CookieDialogue.scss';

var getDocumentBody = function getDocumentBody() {
  var body = typeof window === "object" && window && window.document && window.document.body;
  return body || null;
};
var ElementContext = /*#__PURE__*/createContext(getDocumentBody());
var CookieDialogue = function CookieDialogue(_ref) {
  var _cn;
  var className = _ref.className,
    isVisible = _ref.isVisible,
    content = _ref.content,
    termLink = _ref.termLink,
    config = _ref.config,
    consent = _ref.consent,
    setConsent = _ref.setConsent,
    setToggleCookieDialogue = _ref.setToggleCookieDialogue;
  var rootEl = useContext(ElementContext);
  var t = useTranslate();
  var _useState = useState(true),
    necessary = _useState[0];
  var _useState2 = useState(false),
    statistical = _useState2[0],
    setStatistical = _useState2[1];
  var _useState3 = useState(false),
    marketing = _useState3[0],
    setMarketing = _useState3[1];
  var _useState4 = useState(true),
    load = _useState4[0],
    setLoad = _useState4[1];
  var contentRef = useRef();
  var setCookieObject = function setCookieObject() {
    var cookieKeys = Object.keys({
      necessary: necessary,
      statistical: statistical,
      marketing: marketing
    });
    var cookieValues = Object.values({
      necessary: necessary,
      statistical: statistical,
      marketing: marketing
    });
    var returnObject = Object.fromEntries(cookieKeys.map(function (key, index) {
      return [key, cookieValues[index]];
    }));
    setConsent(JSON.stringify(returnObject));
  };
  var hasMarketingConfig = config.FACEBOOK_PIXEL_ID !== null && config.FACEBOOK_PIXEL_ID !== undefined || config.TIKTOK_PIXEL_ID !== null && config.TIKTOK_PIXEL_ID !== undefined;
  var hasAnalyticsConfig = Array.isArray(config.googleAnalytics) && config.googleAnalytics.length > 0 && config.googleAnalytics !== null && config.googleAnalytics !== undefined;
  var complete = function complete() {
    setToggleCookieDialogue(false);
    window.location.reload();
  };
  var acceptAll = function acceptAll() {
    if (hasAnalyticsConfig) {
      setStatistical(true);
    }
    if (hasMarketingConfig) {
      setMarketing(true);
    }
  };
  useEffect(function () {
    if (load === false) {
      setCookieObject();
    }
    setLoad(false);
  }, [statistical, marketing]);
  useEffect(function () {
    if (rootEl) {
      if (isVisible) {
        rootEl.style.overflow = "hidden";
      } else {
        rootEl.style.overflow = "auto";
      }
    }
    if (isVisible && consent !== "initial") {
      var cookieObj = JSON.parse(consent);
      setStatistical(cookieObj.statistical);
      setMarketing(cookieObj.marketing);
    }
    if (contentRef.current && consent !== "initial") {
      var _contentRef$current$q;
      (_contentRef$current$q = contentRef.current.querySelector(".cms__accordionTitle")) == null || _contentRef$current$q.focus();
    }
  }, [isVisible]);
  return isVisible ? /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.block, (_cn = {}, _cn[styles.visible] = isVisible, _cn), "awardit-cookieDialogue", className)
  }, /*#__PURE__*/React__default.createElement("aside", {
    className: cn(styles.contentBlock, className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.overlay
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: contentRef,
    className: styles.content
  }, /*#__PURE__*/React__default.createElement(CookieDialogueContent, {
    content: content,
    termLink: termLink
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.confirm
  }, /*#__PURE__*/React__default.createElement(Button, {
    variant: "primary",
    className: cn(styles.close, "awardit-confirmNecessary"),
    onClick: function onClick() {
      setCookieObject();
      setTimeout(complete, 500);
    }
  }, /*#__PURE__*/React__default.createElement("span", null, !statistical && !marketing ? t("COOKIE_CONSENT.NECESSARY") : t("COOKIE_CONSENT.SELECTED"))), (hasAnalyticsConfig || hasMarketingConfig) && /*#__PURE__*/React__default.createElement(Button, {
    variant: "primary",
    className: styles.accept,
    onClick: function onClick() {
      acceptAll();
      setTimeout(complete, 500);
    }
  }, /*#__PURE__*/React__default.createElement("span", null, t("COOKIE_CONSENT.ALL")))), /*#__PURE__*/React__default.createElement("div", {
    className: styles.options
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.option
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: styles.label
  }, t("COOKIE_OPTIONS.NECESSARY")), /*#__PURE__*/React__default.createElement(Toggle, {
    className: cn(styles.toggle, styles.disabled),
    name: "necessary",
    value: necessary,
    onChange: function onChange() {}
  })), hasAnalyticsConfig && /*#__PURE__*/React__default.createElement("div", {
    className: styles.option
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: styles.label
  }, t("COOKIE_OPTIONS.STATISTICAL")), /*#__PURE__*/React__default.createElement(Toggle, {
    className: cn(styles.toggle),
    name: "statistical",
    value: statistical,
    onChange: function onChange() {
      return setStatistical(!statistical);
    }
  })), hasMarketingConfig && /*#__PURE__*/React__default.createElement("div", {
    className: styles.option
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: styles.label
  }, t("COOKIE_OPTIONS.MARKETING")), /*#__PURE__*/React__default.createElement(Toggle, {
    className: cn(styles.toggle),
    name: "marketing",
    value: marketing,
    onChange: function onChange() {
      return setMarketing(!marketing);
    }
  }))))))) : null;
};
var CookieDialogueContent = function CookieDialogueContent(_ref2) {
  var content = _ref2.content,
    termLink = _ref2.termLink;
  var root = useRef();
  var toggleAccordionTitle = function toggleAccordionTitle(e) {
    if (e.target instanceof HTMLElement) {
      var element = e.target.parentElement;
      if (element) {
        var isOpen = element.classList.contains("open");
        if (!isOpen) {
          element.classList.add("open");
        } else {
          element.classList.remove("open");
        }
      }
    }
  };
  useEffect(function () {
    var current = root.current;
    if (current) {
      // Bind accordions here
      var accordions = current.querySelectorAll(".cms__accordion");
      for (var _iterator = _createForOfIteratorHelperLoose(accordions), _step; !(_step = _iterator()).done;) {
        var e = _step.value;
        if (e) {
          var title = e.querySelector(".cms__accordionTitle");
          e.style.position = "relative";
          if (title) {
            title.tabIndex = 0;
            title.setAttribute("role", "button");
            title.addEventListener("click", toggleAccordionTitle);
            title.addEventListener("keypress", function (event) {
              if (event.key === "Enter" || event.key === " ") {
                toggleAccordionTitle(event);
              }
            });
          }
        }
      }
    }

    // Un-bind accordions
    return function () {
      if (current) {
        var _accordions = current.querySelectorAll(".cms__accordion");
        for (var _iterator2 = _createForOfIteratorHelperLoose(_accordions), _step2; !(_step2 = _iterator2()).done;) {
          var _e = _step2.value;
          _e.removeEventListener("click", toggleAccordionTitle);
          _e.removeEventListener("keypress", toggleAccordionTitle);
        }
      }
    };
  }, [root]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.textContent
  }, content && content.contentHeading !== undefined ? /*#__PURE__*/React__default.createElement("h2", {
    className: styles.heading
  }, content.contentHeading) : null, content && content.content !== undefined ? /*#__PURE__*/React__default.createElement("div", {
    key: content.url,
    ref: root,
    dangerouslySetInnerHTML: {
      __html: content.content
    },
    className: "typography"
  }) : null, termLink && /*#__PURE__*/React__default.createElement("div", {
    className: styles.termLink
  }, /*#__PURE__*/React__default.createElement("a", {
    href: termLink.url
  }, termLink.title)));
};

export { CookieDialogue, CookieDialogueContent, ElementContext };
//# sourceMappingURL=index.js.map
